<template>
  <section id="content">
    <div id="form-container">
      <NewsSearch
        :onSearch="submitSearch"
        :handleSearch="handleSearch"
        :search="search"
        :onClear="clearSearch"
        :handleFilter="filterNews"
        :news="news"
      />
    </div>
    <label v-if="search" id="search">Searching for: <span>{{ search }}</span></label>
    <label v-if="search" id="total">Total results: <span>{{ filteredNews.length || 0 }}</span></label>
    <Loader :loading="loading"/>
    <code v-show="error" class="error">
      {{error}}
    </code>
    <div>
      <ol v-if="renderedNews">
        <NewsStory v-for="(newsItem, i) in (!search && !filteredNews.length ? renderedNews : filteredNews)"
          :key="i"
          :newsItem="newsItem"
        />
      </ol>
    </div>
  </section>
</template>

<script>
import api from '../../services/api.js';
import NewsStory from './NewsStory';
import NewsSearch from './NewsSearch';
import Loader from './Loader';

export default {
  data() {
    return {
      news: [],
      filteredNews: [],
      loading: false,
      error: '',
      search: '',
      filtered: false,
      renderedNews: []
    };
  },
  components: {
    NewsSearch,
    NewsStory,
    Loader
  },
  created() {
    this.searchNews();
  },
  methods: {
    submitSearch(newValue) {
      this.search = newValue;
      this.searchNews();
    },
    clearSearch() {
      this.resetSearch();
    },
    resetSearch() {
      this.filtered = false;
      this.search = '';
    },
    searchNews() {
      if(!this.news || !this.news.length) {
        this.loading = true;
        api.getNews(this.search)
          .then(response => {
            this.news = response.articles;
            this.renderedNews = this.news;
            this.loading = false;
          })
          .catch(err => {
            this.error = err.message;
            this.loading = false;
          });
      }
    },
    filterNews(keyword) {
      let filteredNews = [];
      if(this.news) {
        for(let i = 0; i < this.news.length; i++) {
          const article = this.news[i];
          if(article) {
            const { title, description } = article;
            const contains = (string, term) =>
              string && string.toLowerCase().includes(term.toLowerCase());
            if(contains(title, keyword) || contains(description, keyword)) {
              filteredNews.push(article);
            }
          }
          this.filtered = true;
        }
        this.filteredNews = filteredNews;
      }
    },
    handleSearch(keyword) {
      this.search = keyword;
    }
  }
};
</script>

<style>
#form-container {
  background-color: var(--bg-color);
  box-shadow: var(--box-shadow-lg);
  padding: 0 1rem 1rem;
  position: fixed;
  width: 100%;
  min-width: 283px;
  top: 0;
  left: 0;
}
#content {
  margin-top: var(--header-height);
}
#total {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media screen and (min-width: 376px) {
  #form-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }
}
</style>
